<template>
  <div class="__wrapper">
    <div class="__container">
      <div class="__section-left">
        <div class="left">
          <div class="brand">
            <img src="../assets/icons/v__icon.svg" />
            <span>{{ getCompany.name | validate }}.</span>
          </div>
          <div class="card blued">
            <div class="title">
              <div class="row">
                <img :src="$fullUrl(
                  'images/profiles/' + getMeProfile.user.profile_picture
                )
                  " />
                <div class="content">
                  <label>{{
                    (getMeProfile.user.first_name +
                      " " +
                      getMeProfile.user.last_name)
                    | validate
                  }}</label>
                  <span>Manager</span>
                </div>
              </div>
              <img src="../assets/icons/arrow___down.svg" class="endy" />
            </div>
          </div>
          <div class="card">
            <div class="wrapper">
              <h2>Dashboard navigation</h2>
              <ul>
                <li :class="{ active_link: tab1 }" @click="tab1 = true">
                  Heat maps
                </li>
                <li :class="{ active_link: tab2 }" @click="tab2 = true">
                  Consultants
                </li>
                <li :class="{ active_link: tab3 }" @click="tab3 = true">
                  Projects
                </li>
                <li :class="{ active_link: tab4 }" @click="tab4 = true">
                  Subcontracts
                </li>
                <li :class="{ active_link: tab5 }" @click="tab5 = true">
                  Customers
                </li>
                <li :class="{ active_link: tab6 }" @click="tab6 = true">
                  Leads
                </li>
              </ul>
              <h2>Profile navigation</h2>
              <ul>
                <li>Profile</li>
                <li>Customers</li>
                <li>Leads</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="__section-center">
        <div class="page" :class="{ __hide: !tab1, __show: tab1 }">
          <div class="page-body heat-map">
            <h2>Heat map</h2>
            <div class="search">
              <input type="text" placeholder="search here" class="search-input card" />
              <div class="card">
                <div class="filter">
                  <span>Sort By</span>
                  <select>
                    <option>Monthly</option>
                    <option>daily</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="dash-icons">
                <div class="item">
                  <img src="../assets/icons/dash-project.svg" />
                  <span class="number">456</span>
                  <div class="text">Total projects</div>
                </div>
                <div class="item">
                  <img src="../assets/icons/dash-verified.svg" />
                  <span class="number">456</span>
                  <div class="text">Total projects</div>
                </div>
                <div class="item">
                  <img src="../assets/icons/dash-consultants.svg" />
                  <span class="number">456</span>
                  <div class="text">Total projects</div>
                </div>
                <div class="item border-less">
                  <img src="../assets/icons/dash-countries.svg" />
                  <span class="number">456</span>
                  <div class="text">Total projects</div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="map">
                <div class="left">
                  <h2>Name</h2>
                  <h2>Customer/Leads</h2>
                </div>
                <div class="right">
                  <div class="header">
                    <div class="bar-line">
                      <div class="bar"></div>
                      <span>2019</span>
                      <div class="bar"></div>
                    </div>
                    <div class="months p0">
                      <div class="month">Jan</div>
                      <div class="month">Feb</div>
                      <div class="month">Mar</div>
                      <div class="month">Apr</div>
                      <div class="month">May</div>
                      <div class="month">Jun</div>
                      <div class="month">Jul</div>
                      <div class="month">Aug</div>
                      <div class="month">Sep</div>
                      <div class="month">Oct</div>
                      <div class="month">Nov</div>
                      <div class="month">Dec</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="map-body">
                <div class="section1">
                  <div class="lined">
                    <label>Prince</label>
                    <span>Consultified</span>
                  </div>
                  <div class="lined">
                    <label>Denis</label>
                    <span>Consultified</span>
                  </div>
                  <div class="lined">
                    <label>Elie</label>
                    <span>Consultified</span>
                  </div>
                  <div class="lined">
                    <label>Brian</label>
                    <span>Consultified</span>
                  </div>
                  <div class="lined">
                    <label>Leon</label>
                    <span>Consultified</span>
                  </div>
                </div>
                <div class="section2">
                  <div class="months">
                    <div class="brick green"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick"></div>
                    <div class="brick"></div>
                    <div class="brick yellow"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                  </div>
                  <div class="months">
                    <div class="brick green"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick"></div>
                    <div class="brick"></div>
                    <div class="brick yellow"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                  </div>
                  <div class="months">
                    <div class="brick green"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick"></div>
                    <div class="brick"></div>
                    <div class="brick yellow"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                  </div>
                  <div class="months">
                    <div class="brick green"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick"></div>
                    <div class="brick"></div>
                    <div class="brick yellow"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                  </div>
                  <div class="months">
                    <div class="brick green"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick"></div>
                    <div class="brick"></div>
                    <div class="brick yellow"></div>
                    <div class="brick yellow"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                    <div class="brick green"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="lables">
              <div class="uno">
                <div class="brick green"></div>
                <span>Booked 100%</span>
              </div>
              <div class="uno">
                <div class="brick lighter"></div>
                <span>Booked 100%</span>
              </div>
              <div class="uno">
                <div class="brick yellow"></div>
                <span>Booked 100%</span>
              </div>
              <div class="uno">
                <div class="brick red"></div>
                <span>Booked 100%</span>
              </div>
              <div class="uno">
                <div class="brick"></div>
                <span>Booked 100%</span>
              </div>
            </div>
            <div class="graphs">
              <div class="pie card">
                <graph-pie :width="200" :height="200" :values="values" :names="legends" :active-index="[0, 2]"
                  :active-event="'click'" :show-text-type="'outside'">
                  <legends :names="names"></legends>
                  <tooltip :names="names"></tooltip>
                </graph-pie>
              </div>
              <div class="pie card">
                <graph-line :width="300" :height="200" :shape="'curve'" :axis-min="0" :axis-max="50" :axis-reverse="true"
                  :axis-full-mode="true" :labels="legends" :names="names" :values="values">
                  <tooltip :names="names" :position="'right'"></tooltip>
                  <legends :names="names"></legends>
                  <guideline :tooltip-y="true"></guideline>
                </graph-line>
              </div>
            </div>
          </div>
        </div>
        <div class="page" :class="{ __hide: !tab2, __show: tab2 }">
          <div class="page-body consultants-page">
            <h2>Consultants</h2>
            <div class="search">
              <input type="text" placeholder="search here" class="search-input card" />
              <div class="card">
                <div class="filter">
                  <span>Sort By</span>
                  <select>
                    <option>Last</option>
                    <option>First</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="titles">
              <span>Profile image and name</span>
              <span>Current client</span>
              <span>Estimated period</span>
              <span>Date Joined</span>
            </div>
            <div class="card">
              <div class="list">
                <div class="item" v-for="(person, i) in consultants">
                  <div>
                    <img :src="$fullUrl('images/profiles/' + person.profile_picture)
                        " />
                    <span>{{
                      (person.first_name + " " + person.last_name) | validate
                    }}</span>
                  </div>
                  <span>Consultified</span>
                  <span>2 weeks</span>
                  <span>12-Dec-2017</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page" :class="{ __hide: !tab3, __show: tab3 }">
          <div class="page-body consultants-page">
            <h2>Projects</h2>
            <div class="search">
              <input type="text" placeholder="search here" class="search-input card" />
              <div class="card">
                <div class="filter">
                  <span>Sort By</span>
                  <select>
                    <option>Monthly</option>
                    <option>daily</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="titles">
              <span>Project Name</span>
              <span>Company</span>
              <span>Members</span>
              <span>Time</span>
            </div>
            <div class="card">
              <div class="list">
                <div class="consultant">
                  <div class="person">
                    <div class="content">
                      <span>Green city project</span>
                      <div class="bar"></div>
                    </div>
                  </div>
                  <span>Google Inc.</span>
                  <span>2 members</span>
                  <div class="date">
                    <span>12-Dec-2017</span>
                  </div>
                </div>
                <div class="consultant">
                  <div class="person">
                    <div class="content">
                      <span>Green city project</span>
                      <div class="bar"></div>
                    </div>
                  </div>
                  <span>Google Inc.</span>
                  <span>2 members</span>
                  <div class="date">
                    <span>12-Dec-2017</span>
                  </div>
                </div>
                <div class="consultant">
                  <div class="person">
                    <div class="content">
                      <span>Green city project</span>
                      <div class="bar"></div>
                    </div>
                  </div>
                  <span>Google Inc.</span>
                  <span>2 members</span>
                  <div class="date">
                    <span>12-Dec-2017</span>
                  </div>
                </div>
                <div class="consultant">
                  <div class="person">
                    <div class="content">
                      <span>Green city project</span>
                      <div class="bar"></div>
                    </div>
                  </div>
                  <span>Google Inc.</span>
                  <span>2 members</span>
                  <div class="date">
                    <span>12-Dec-2017</span>
                  </div>
                </div>
                <div class="consultant">
                  <div class="person">
                    <div class="content">
                      <span>Green city project</span>
                      <div class="bar"></div>
                    </div>
                  </div>
                  <span>Google Inc.</span>
                  <span>2 members</span>
                  <div class="date">
                    <span>12-Dec-2017</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page" :class="{ __hide: !tab4, __show: tab4 }">
          <div class="page-body heat-map">
            <h2>Subcontracts</h2>
            <div class="search">
              <input type="text" placeholder="search here" class="search-input card" />
              <div class="card">
                <div class="filter">
                  <span>Sort By</span>
                  <select>
                    <option>Monthly</option>
                    <option>daily</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page" :class="{ __hide: !tab5, __show: tab5 }">
          <div class="page-body heat-map">
            <h2>Customers</h2>
            <div class="search">
              <input type="text" placeholder="search here" class="search-input card" />
              <div class="card">
                <div class="filter">
                  <span>Sort By</span>
                  <select>
                    <option>Monthly</option>
                    <option>daily</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page" :class="{ __hide: !tab6, __show: tab6 }">
          <div class="page-body heat-map">
            <h2>Leads</h2>
            <div class="search">
              <input type="text" placeholder="search here" class="search-input card" />
              <div class="card">
                <div class="filter">
                  <span>Sort By</span>
                  <select>
                    <option>Monthly</option>
                    <option>daily</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page" :class="{ __hide: !tab7, __show: tab7 }">
          <div class="page-body heat-map">
            <h2>Heat map</h2>
            <div class="search">
              <input type="text" placeholder="search here" class="search-input card" />
              <div class="card">
                <div class="filter">
                  <span>Sort By</span>
                  <select>
                    <option>Monthly</option>
                    <option>daily</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CompanyAdmin",
  computed: {
    ...mapGetters(["getCompany", "getMeProfile"]),
    consultants() {
      return this.getCompany.consultants;
    },
  },
  data() {
    return {
      values: [10, 5, 5, 5],
      names: [
        "Created leads",
        "Outside leads",
        "Pending leads",
        "Completed leads",
      ],
      legends: ["Created", "Outside", "Pending", "Completed"],
      tab1: true,
      tab2: false,
      tab3: false,
      tab4: false,
      tab5: false,
      tab6: false,
      tab7: false,
    };
  },
  mounted() {
    this.$store.dispatch("GET_ME_PROFILE_DATA");
    this.$store.dispatch("GET_COMPANY_INFO", { id: this.$route.params.id });
  },
  watch: {
    tab1: function (val) {
      if (val) {
        this.tab2 = false;
        this.tab3 = false;
        this.tab4 = false;
        this.tab5 = false;
        this.tab6 = false;
        this.tab7 = false;
      }
    },
    tab2: function (val) {
      if (val) {
        this.tab1 = false;
        this.tab3 = false;
        this.tab4 = false;
        this.tab5 = false;
        this.tab6 = false;
        this.tab7 = false;
      }
    },
    tab3: function (val) {
      if (val) {
        this.tab2 = false;
        this.tab1 = false;
        this.tab4 = false;
        this.tab5 = false;
        this.tab6 = false;
        this.tab7 = false;
      }
    },
    tab4: function (val) {
      if (val) {
        this.tab2 = false;
        this.tab3 = false;
        this.tab1 = false;
        this.tab5 = false;
        this.tab6 = false;
        this.tab7 = false;
      }
    },
    tab5: function (val) {
      if (val) {
        this.tab2 = false;
        this.tab3 = false;
        this.tab4 = false;
        this.tab1 = false;
        this.tab6 = false;
        this.tab7 = false;
      }
    },
    tab6: function (val) {
      if (val) {
        this.tab2 = false;
        this.tab3 = false;
        this.tab4 = false;
        this.tab5 = false;
        this.tab1 = false;
        this.tab7 = false;
      }
    },
    tab7: function (val) {
      if (val) {
        this.tab2 = false;
        this.tab3 = false;
        this.tab4 = false;
        this.tab5 = false;
        this.tab6 = false;
        this.tab1 = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.__wrapper {
  background: #f5f9fc;
  min-height: 93%;

  .__container {
    margin: 0 auto;
    width: 70%;
    display: grid;
    grid-template-columns: 1fr 2.5fr;
    grid-column-gap: 20px;

    @media (min-width: 300px) and (max-width: 630px) {
      grid-template-columns: 1fr;
      width: 90%;
    }

    .__section-left {
      margin-top: 20px;
      width: 100%;

      .left {
        width: 100%;

        .brand {
          margin-bottom: 10px;

          img {
            width: 40px;
            height: 40px;
            border-radius: 100%;
          }

          span {
            color: #1885ad;
            margin-left: 10px;
          }
        }

        .title {
          display: flex;
          padding: 10px;
          width: 100%;
          justify-content: space-between;

          img {
            width: 35px;
            height: 35px;
            border-radius: 100%;
          }

          .row {
            margin-left: 10px;

            .content {
              display: flex;
              flex-direction: column;
              margin-left: 10px;

              label {
                color: #fff;
                font-size: 18px;
              }

              span {
                color: #fff;
                font-size: 12px;
              }
            }
          }

          .endy {
            width: 20px;
            margin-top: 10px;
            height: 20px;
          }
        }

        .wrapper {
          padding: 20px 10px;

          h2 {
            font-size: 18px;
            margin-left: 10px;
            color: #535353;
          }

          ul {
            margin-top: 20px;
            margin-left: 0;

            li {
              list-style: none;
              padding: 7px 10px;
              border-radius: 5px;
              color: #959595;
              margin-left: 0;
              font-size: 14px;
              margin-bottom: 5px;

              &:hover {
                background: #1ba5a4;
                color: #fff;
                cursor: pointer;
              }
            }

            .active_link {
              background: #1ba5a4;
              color: #fff;
              cursor: pointer;
            }
          }
        }
      }
    }

    .__section-center {
      position: relative;

      .page {
        position: absolute;
        left: 0;
        padding-top: 70px;
        width: 100%;
        height: 100%;

        .page-body {
          display: flex;
          flex-direction: column;

          h2 {
            color: #535353;
            font-size: 25px;
          }

          .search {
            display: grid;
            grid-column-gap: 20px;
            grid-template-columns: 2.2fr 1fr;

            .search-input {
              background-color: #fff;
              border-radius: 5px;
              outline: none;
              background-position: center right;
              background-size: 15px 15px;
              padding: 5px 10px;
              font-size: 14px;
              background-origin: content-box;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.16);
              background-repeat: no-repeat;
              background-image: url("../assets/icons/back_search.svg");
            }

            .filter {
              display: flex;
              padding: 5px 10px 0 10px;
              justify-content: space-between;

              span {
                color: #959595;
                font-size: 12px;
              }

              select {
                font-size: 12px;
                color: #535353;
                background-origin: content-box;
                outline: none;
                flex-grow: 1;
                margin-left: 40%;
                background-position: center right;
                background-image: url("../assets/icons/arrow_down_black.svg");
                background-color: transparent;
                background-repeat: no-repeat;
              }
            }
          }

          .dash-icons {
            display: grid;
            padding: 20px 10px;
            grid-template-columns: 1fr 1fr 1fr 1fr;

            .item {
              margin-right: 10px;
              margin-left: 20px;
              border-right: 1px solid #959595;

              .number {
                margin-left: 10px;
                color: #535353;
                font-size: 17px;
              }

              .text {
                color: #535353;
                font-size: 12px;
                margin-top: 10px;
              }
            }

            .border-less {
              border: none;
            }
          }

          .map {
            padding: 20px;
            display: grid;
            grid-template-columns: 1fr 1fr;

            .left {
              display: grid;
              grid-template-columns: 1fr 1fr;

              h2 {
                color: #1885ad;
                font-size: 12px;
                font-weight: bold;
              }
            }

            .right {
              .header {
                .bar-line {
                  display: flex;

                  span {
                    margin-left: 10px;
                    margin-right: 10px;
                    color: #1ba5a4;
                    font-size: 13px;
                    font-weight: bold;
                  }

                  .bar {
                    flex-grow: 1;
                    height: 1px;
                    align-self: center;
                    opacity: 0.3;
                    background: rgb(112, 112, 112);
                  }
                }

                .months {
                  display: flex;

                  .month {
                    font-size: 9px;
                    font-weight: normal;
                    color: #000000;
                    padding-left: 5px;
                    padding-right: 5px;
                  }
                }
              }
            }
          }

          .map-body {
            margin-top: -10px;
            padding: 0 20px 20px 20px;
            display: grid;
            grid-template-columns: 1fr 1fr;

            .section1 {
              .lined {
                display: grid;
                padding: 2px !important;
                margin-top: 5px;
                grid-template-columns: 1fr 1fr;

                &:nth-of-type(odd) {
                  background: #f5f5f5;
                }

                label {
                  color: #000000;
                  font-size: 11px;
                  margin: 0 !important;
                  font-weight: bold;
                }

                span {
                  color: #535353;
                  margin: 0 !important;
                  font-size: 11px;
                  font-weight: normal;
                }
              }
            }

            .section2 {
              .months {
                display: flex;
                padding-top: 10px;
                padding-bottom: 5px;

                .brick {
                  width: 20px;
                  height: 10px;
                  border-radius: 3px;
                  margin-right: 4px;
                  background: #bebebe;
                }

                .green {
                  background: #00b24b;
                }

                .yellow {
                  background: #8dd439;
                }
              }
            }
          }

          .lables {
            width: 90%;
            margin: 0 auto;
            display: flex;
            margin-bottom: 20px;
            justify-content: space-between;

            .uno {
              display: flex;

              span {
                margin-left: 5px;
                color: #000000;
                margin-top: -3px;
                font-size: 11px;
              }
            }
          }

          .graphs {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 20px;

            .pie {
              padding: 20px;
            }
          }
        }

        .consultants-page {
          .titles {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;

            span {
              text-align: center;
              color: #959595;
              font-size: 12px;
            }
          }

          .list {
            padding: 20px;

            .item {
              display: flex;
              padding: 5px 30px;
              justify-content: space-between;

              &:nth-of-type(odd) {
                background: #ededed;

                input[type="checkbox"] {
                  background: #fff;
                }
              }

              &:nth-of-type(even) {
                input[type="checkbox"] {
                  background: #ededed;
                }
              }

              div {
                display: flex;

                img {
                  margin-right: 20px;
                  width: 35px;
                  height: 35px;
                  border-radius: 100%;
                }

                span {
                  color: #1885ad;
                  font-size: 14px;
                }
              }

              span {
                color: #707070;
                font-size: 14px;
                margin-top: 6px;
              }

              input[type="checkbox"] {
                background: #fff;
                outline: none;
                margin-left: 10px;
                margin-top: 3px;
                padding-left: 5px;
                padding-right: 5px;
                -webkit-appearance: button;
                color: #707070;
                white-space: nowrap;
                overflow: hidden;
                border-radius: 5px;
                width: 20px;
                height: 20px;

                &:checked {
                  background-color: #707070;
                }
              }
            }

            .consultant {
              display: grid;
              padding-left: 20px;
              margin-bottom: 10px;
              padding-bottom: 5px;
              padding-right: 20px;
              border: 0.5px solid rgba(112, 112, 112, 0.4);
              border-radius: 5px;
              grid-template-columns: 1.5fr 1fr 1fr 1fr;

              .person {
                display: flex;
                padding-top: 5px;

                img {
                  width: 42px;
                  height: 42px;
                  border-radius: 100%;
                }

                .content {
                  display: flex;
                  margin-left: 10px;
                  flex-direction: column;
                  color: #535353;
                  font-weight: normal;
                  font-size: 13px;

                  span {
                    margin-top: 3px;
                  }

                  .bar {
                    background: #1885ad;
                    border-radius: 3px;
                    width: 20px;
                    margin-top: 4px;
                    height: 5px;
                  }
                }
              }

              .button {
                background: #bebebe;
                height: 25px;
                font-size: 12px;
                margin-top: 5px;
                margin-bottom: 0 !important;

                span {
                  color: #fff;
                }
              }

              .date {
                text-align: center;
                color: #959595;
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
}

.card {
  background: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);
  border: none;
  margin-bottom: 20px;
}

.blued {
  background: #1885ad;
  margin-bottom: 0;
}

.p0 {
  padding: 0 !important;
}

.brick {
  width: 20px;
  height: 10px;
  border-radius: 3px;
  margin-right: 4px;
  background: #bebebe;
}

.green {
  background: #00b24b;
}

.yellow {
  background: #8dd439 !important;
}

.lighter {
  background: #ffff00;
}

.red {
  background: #ff0000;
}

.__hide {
  opacity: 0;
  pointer-events: none;
  animation: slide-out 0.9s forwards;
  -webkit-animation: slide-out 0.9s forwards;
}

.__show {
  opacity: 1;
  pointer-events: auto;
  /*animation: slide-in 0.5s forwards;*/
  /*-webkit-animation: slide-in 0.5s forwards;*/
}</style>